import http from "../../http-common";

const getImages = (productId) => http.get(`/ProductMotulImage/${productId}`);
const uploadImage = (productId, formData) =>
    http.post(`/ProductMotulImage/${productId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
const deleteImage = (productId, imageId) => http.delete(`/ProductMotulImage/${productId}/${imageId}`);

export default {
    getImages,
    uploadImage,
    deleteImage
};
